import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_MODULE } from '../../../../Constants';
import { toast } from 'react-toastify';

export const useInsertRevision = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const insertRevisionHook = async (moduleId, revision, handleUpdates) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_MODULE}/${moduleId}/module-revision`,
        {module_revision: revision}
      );

      const status = response?.status;
      if (status === 200) {
        setSuccess(true);
        toast.success(`Lessons creating successful.`, {
                position: toast.POSITION.BOTTOM_LEFT
        });
        handleUpdates()
      } else {
        setError("Failed to create revision");
      }
    } catch (error) {
      setError("An error occurred while creating revision");
    } finally {
      setLoading(false);
    }
  };

  return [ insertRevisionHook, loading, error, success ];
};